import IncentiveOffersMyOperations from 'modules/incentivesMarket/pages/IncentiveOffersMyOperations';
import { IncentivesMarketProvider } from '../contexts/IncentivesMarketContext';

const IncentiveOffersMyOperationsContainer = () => (
  <IncentivesMarketProvider>
    <IncentiveOffersMyOperations />
  </IncentivesMarketProvider>
);

export default IncentiveOffersMyOperationsContainer;
